import type { IconSvgObject } from './types';

const FlyingHumanIcon: IconSvgObject = [
  ["path", { d: "M15.9939 5.49805C15.9939 6.32648 15.322 6.99805 14.4931 6.99805C13.6641 6.99805 12.9922 6.32648 12.9922 5.49805C12.9922 4.66962 13.6641 3.99805 14.4931 3.99805C15.322 3.99805 15.9939 4.66962 15.9939 5.49805Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 3C20.5 5 19.5 8 15 9C11.4857 9.78095 8.5 10 7 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.5 9.5C13.5 9.5 13 20.5 5 21M17 8.5C17 8.5 17.5 17 3 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FlyingHumanIcon;
